import "core-js/modules/es.array.map.js";
import cx from 'classnames';
import React from 'react';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import Button from '../button';
import SafeArea from '../safe-area';
import { useConfig } from '../config-provider';
import { shareChannelList, shareChannelCollection } from './share-channel';
var classPrefix = 'nib-share-channel-picker';
var entities = shareChannelCollection.entities;
var defaultProps = {
  channels: shareChannelList.map(function (x) {
    return x.value;
  }),
  cancelButton: false,
  cancelText: '取消',
  autoSafeArea: true
};
export var ShareChannelPicker = function ShareChannelPicker(p) {
  var _cx;

  var _useConfig = useConfig(),
      debug = _useConfig.debug;

  var props = mergeProps(defaultProps, p);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix, (_cx = {}, _cx[classPrefix + "-debug"] = debug, _cx)),
    style: {
      // @ts-ignore
      '--column-count': Math.min(props.channels.length, 4)
    }
  }, Boolean(props.title) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-header-title"
  }, props.title)), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body"
  }, props.channels.map(function (channel, index) {
    var entity = entities[channel];
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: classPrefix + "-channel"
    }, /*#__PURE__*/React.createElement("div", {
      className: classPrefix + "-channel-inner",
      onClick: function onClick() {
        var _a;

        (_a = props.onChannelClick) === null || _a === void 0 ? void 0 : _a.call(props, entity.value);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classPrefix + "-channel-icon"
    }, entity.icon), /*#__PURE__*/React.createElement("div", {
      className: classPrefix + "-channel-text"
    }, entity.text)));
  })), props.cancelButton && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    size: "large",
    className: classPrefix + "-action-cancel",
    onClick: props.onCancelClick
  }, props.cancelText)), props.autoSafeArea && /*#__PURE__*/React.createElement(SafeArea, {
    position: "bottom"
  })));
};